import type { FC, MouseEvent, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowUp } from 'lucide-react'
import { useSmoothScroll } from '@/components/generals/smooth-scroll'
import { NAV_LINKS } from '@/constants/aerive'

const SiteFooter: FC = (): ReactNode => {
    const { scrollTo } = useSmoothScroll()

    const go = (href: string) => (event: MouseEvent<HTMLAnchorElement>): void => {
        event.preventDefault()
        scrollTo(href)
    }

    return (
        <footer className='relative z-10 border-t border-champagne/15 bg-obsidian px-5 pb-28 pt-12 text-ivory md:px-[6vw] md:pb-12'>
            <div className='flex flex-col gap-10 md:flex-row md:items-center md:justify-between'>
                <a
                    href='#hero'
                    onClick={(event) => {
                        event.preventDefault()
                        scrollTo(0)
                    }}
                    className='pl-[0.32em] font-heading text-[1.8rem] font-medium leading-none tracking-[0.32em] text-champagne'
                >
                    AERIVE
                </a>

                <nav aria-label='Footer' className='flex flex-wrap gap-x-8 gap-y-3'>
                    {NAV_LINKS.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            onClick={go(link.href)}
                            className='text-[11px] uppercase tracking-[0.24em] text-ivory/70 transition-colors hover:text-champagne focus-visible:text-champagne focus-visible:outline-none'
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>

                <button
                    type='button'
                    onClick={() => scrollTo(0)}
                    className='inline-flex items-center gap-3 self-start text-[11px] uppercase tracking-[0.24em] text-ivory/70 transition-colors hover:text-champagne md:self-auto'
                >
                    Back to the window
                    <span className='flex size-9 items-center justify-center rounded-full border border-champagne/30 text-champagne'>
                        <ArrowUp className='size-4' />
                    </span>
                </button>
            </div>

            <div className='mt-12 flex flex-col gap-3 border-t border-champagne/10 pt-6 text-[10px] uppercase tracking-[0.22em] text-smoke md:flex-row md:justify-between'>
                <p>© 2026 AERIVE. All rights reserved.</p>
                <Link href='/privacy' className='transition-colors hover:text-champagne focus-visible:text-champagne focus-visible:outline-none'>
                    Privacy policy
                </Link>
                <p>Private aviation, planned around you</p>
            </div>
        </footer>
    )
}

export default SiteFooter
